export default __webpack_public_path__ + "maps-examples-light-example-thumbnail-480-dd78dca6f933db14389349f0096add7a.png";